import { memo, createPortal } from 'preact/compat';
import intl from 'react-intl-universal';
const MyComponent = ({ closeModal, title, okBtn, cancelBtn, hideCancelBtn, children, onCancel, onOk }) => {
  const domEl = document.getElementById('modal-root');

  if (!domEl) return null;
  return createPortal(
    <div className='my-modal'>
      <div className='ant-modal-mask'></div>

      <div tabIndex='-1' className='ant-modal-wrap confirm-modal' role='dialog'>
        <div
          role='document'
          className='ant-modal ant-modal-confirm ant-modal-confirm-confirm'
          style='width: 470px; transform-origin: 601px 254px;'
        >
          <div className='ant-modal-content'>
            <button type='button' aria-label='Close' className='ant-modal-close' onClick={closeModal}>
              <span className='ant-modal-close-x'>
                <span role='img' aria-label='close' className='anticon anticon-close ant-modal-close-icon'>
                  <svg
                    viewBox='64 64 896 896'
                    focusable='false'
                    data-icon='close'
                    width='1em'
                    height='1em'
                    fill='currentColor'
                    aria-hidden='true'
                  >
                    <path d='M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 00203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z'></path>
                  </svg>
                </span>
              </span>
            </button>
            <div className='ant-modal-body'>
              <div className='ant-modal-confirm-body-wrapper'>
                <div className='ant-modal-confirm-body'>
                  <span
                    role='img'
                    aria-label='exclamation-circle'
                    className='anticon anticon-exclamation-circle'
                    style='font-size: 20px; color: #5684EF;'
                  >
                    <svg
                      viewBox='64 64 896 896'
                      focusable='false'
                      data-icon='exclamation-circle'
                      width='1em'
                      height='1em'
                      fill='currentColor'
                      aria-hidden='true'
                    >
                      <path d='M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'></path>
                      <path d='M464 688a48 48 0 1096 0 48 48 0 10-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z'></path>
                    </svg>
                  </span>
                  <span className='ant-modal-confirm-title'>{title}</span>
                  <div className='ant-modal-confirm-content'>{children}</div>
                </div>
                <div className='ant-modal-confirm-btns'>
                  {!hideCancelBtn && (
                    <button type='button' className='ant-btn ant-btn-default' onClick={onCancel}>
                      <span>{cancelBtn}</span>
                    </button>
                  )}
                  <button type='button' className='ant-btn ant-btn-primary' onClick={onOk}>
                    <span>{okBtn}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>,
    domEl,
  );
};

const Modal = memo(MyComponent);

export default Modal;
